import React, { ReactNode, useId } from 'react';

import { LangTag, Req } from '../base';
import * as S from './styles';

interface IProps {
  label?: ReactNode;
  disabled?: boolean | undefined;
  // -- //
  onChange?: (val: any) => void;
  style?: object;
  id?: string;
  error?: boolean;
  success?: boolean;
  message?: string | boolean;
  height?: string;
  type?: string;
  name?: string;
  onBlur?: (val: object) => void;
  onFocus?: (val: object) => void;
  value?: string;
  icon?: ReactNode;
  inputStyle?: object;
  labelStyle?: object;
  readOnly?: boolean;
  inputSize?: number;
  maxLength?: number;
  // -- //
  refrence?: any;
  className?: string;
  placeholder?: string;
  defaultValue?: string;
  arrow?: boolean;
  /**
   * Writing direction of the field's own content. 'rtl' also switches the
   * control to --font-ar and right-aligns it, through `ctrlBase`. Set this on
   * the Arabic side of a bilingual pair; the panel's chrome stays LTR.
   */
  dir?: 'ltr' | 'rtl';
  /** Language marker beside the label — the design's `.lang-tag`. */
  langTag?: string;
  /** Renders the design's required asterisk after the label. */
  required?: boolean;
}

const TextInput: React.FC<IProps> = ({
  label,
  id,
  disabled,
  style,
  error,
  success,
  message,
  height,
  onChange,
  type,
  name,
  onBlur,
  value,
  icon,
  inputStyle,
  readOnly,
  inputSize,
  maxLength,
  className,
  refrence,
  onFocus,
  placeholder,
  labelStyle,
  defaultValue,
  arrow,
  dir,
  langTag,
  required
}) => {
  const autoId = useId();

  return (
    <S.inputContainer
      style={style}
      className={error ? `error ${className}` : success ? `success ${className}` : `${className}`}
    >
      {label ? (
        <S.label className="input-label" style={labelStyle} htmlFor={id ? id : `${autoId}`}>
          {label}
          {langTag ? <LangTag>{langTag}</LangTag> : <></>}
          {required ? <Req aria-hidden="true">*</Req> : <></>}
        </S.label>
      ) : (
        <></>
      )}
      <S.InputBox>
        <S.input
          ref={refrence}
          maxLength={maxLength}
          size={inputSize}
          readOnly={readOnly}
          name={name}
          type={type}
          onChange={onChange}
          id={id ? id : `${autoId}`}
          disabled={disabled}
          placeholder={placeholder}
          style={{
            ...(height ? { height, lineHeight: height } : {}),
            ...(icon ? { paddingRight: '35px' } : {}),
            ...inputStyle
          }}
          onBlur={onBlur}
          onFocus={onFocus}
          value={value}
          defaultValue={defaultValue}
          dir={dir}
          $arrow={arrow}
        />
        {icon ? <S.Icon>{icon}</S.Icon> : <></>}
      </S.InputBox>
      {message ? (
        <S.message className={error ? 'error-message' : success ? 'success-message' : ''}>{message}</S.message>
      ) : (
        <></>
      )}
    </S.inputContainer>
  );
};

export default TextInput;
